
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Boutique = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <Link to="/">
              <Button variant="ghost" className="mb-4">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Retour à l'accueil
              </Button>
            </Link>
          </div>

          {/* Livret Section */}
          <section>
            <div className="grid md:grid-cols-2 gap-8 items-center bg-accent/10 p-8 rounded-lg">
              <div className="flex justify-center md:justify-start">
                <img 
                  src="/lovable-uploads/3b708940-e395-4602-bf56-69aa2a5f74fe.png" 
                  alt="Couverture du livret de rituels et décrets par Meredith Meneora"
                  className="w-80 h-auto object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className="text-center md:text-left">
                <h1 className="text-4xl font-bold text-primary mb-6">Livret de rituels & décrets d'alignement</h1>
                <p className="text-lg mb-4">
                  🕊️ Un petit livret vibratoire, à télécharger, pour t'accompagner dans tes rituels, tes soins, ou tes instants à toi.
                </p>
                <p className="text-lg mb-6">
                  ✨ Des mots alignés à ton axe, pour ouvrir l'espace, poser l'intention, vibrer ton chemin.
                </p>
                <div className="mb-6">
                  <p className="text-lg mb-2">💰 Tarif : 15 €</p>
                  <p className="text-lg">📎 Format : PDF téléchargeable</p>
                </div>
                <a href="https://payhip.com/b/n4mBO" target="_blank" rel="noopener noreferrer">
                  <Button size="lg" className="w-full md:w-auto">
                    Télécharger
                  </Button>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Boutique;
